import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';

import Global from '../../store/global-selectors';
import { pages } from '../../pages/settings/nav-items';
import { UserPermissionService } from '../../services/user-permission-service';

export const ActiveSubscriptionRequired = ({ children }) => {
  const isSubscriptionExpired = useSelector(Global.selectSellerIsSubscriptionExpired);
  const userRoles = useSelector(Global.selectUseruserRoles);
  const isSysAdmin = UserPermissionService.userIsSystemAdministrator(userRoles);

  return !isSubscriptionExpired || isSysAdmin ? (
    children
  ) : (
    <Redirect to={`/${pages.settings.location}/${pages.paymentAndSubscription.location}`} />
  );
};

ActiveSubscriptionRequired.propTypes = {
  children: PropTypes.node.isRequired,
};
